import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import SelectCategory from '../pages/SelectCategory'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import SelectExperiment from '../pages/SelectExperiment'
import SelectExperimentDetail from '../pages/SelectExperimentDetail'
import Tray from '../pages/Tray'
import SelectContent from '../pages/SelectContent'
import SelectCategory2 from '../pages/SelectCategory2'
import SelectTrayContent from '../pages/SelectTrayContent'
import ExperimentLog from '../pages/ExperimentLog'
import CategoryRoutes from './CategoryRoutes'
import {useIntl} from 'react-intl'
import TrayRoutes from './TrayRoutes'
import ContentLog from '../pages/ContentLog'

const PrivateRoutes = () => {
  const intl = useIntl()

  const selecCategoryBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '/selectCategory',
      isSeparator: true,
      isActive: false,
    },
  ]
  const trayBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '/tray',
      isSeparator: true,
      isActive: false,
    },
  ]
  const trayContentBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Tray',
      path: '/tray',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '/tray/selectTrayContent',
      isSeparator: true,
      isActive: true,
    },
  ]
  const selecExperimentBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Units',
      path: '/selectCategory',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '/selectCategory/selectExperiment',
      isSeparator: true,
      isActive: false,
    },
  ]
  const selecExperimentDetailBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Units',
      path: '/selectCategory',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '/selectCategory/selectExperiment/selectExperimentDetail',
      isSeparator: true,
      isActive: false,
    },
  ]
  const reportBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '/report',
      isSeparator: true,
      isActive: false,
    },
  ]

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route
          path='selectCategory'
          element={
            <>
              <PageTitle breadcrumbs={selecCategoryBreadCrumbs}>Units</PageTitle>
              <SelectCategory2 />
            </>
          }
        />
        {/*}
         <Route
          path='selectCategory/selectExperiment'
          element={
            <>
              <PageTitle breadcrumbs={selecExperimentBreadCrumbs}>Experiment</PageTitle>
              <SelectExperiment />
            </>
          }
        />
        <Route
          path='selectCategory/selectExperiment/selectExperimentDetail'
          element={
            <>
              <PageTitle breadcrumbs={selecExperimentDetailBreadCrumbs}>
                Experiment Detail
              </PageTitle>
              <SelectContent />
            </>
          }
        />{*/}
        <Route path='/units/*' element={<CategoryRoutes />} />
        <Route path='/trays/*' element={<TrayRoutes />} />
        {/*}
        <Route
          path='/trays'
          element={
            <>
              <PageTitle breadcrumbs={trayBreadCrumbs}>
                {intl.formatMessage({id: 'SLIDEMENU.TRAY'})}
              </PageTitle>
              <Tray />
            </>
          }
        />
        <Route
          path='/tray/selectTrayContent'
          element={
            <>
              <PageTitle breadcrumbs={trayContentBreadCrumbs}>
                {intl.formatMessage({id: 'SLIDEMENU.TRAYCONTENT'})}
              </PageTitle>
              <SelectTrayContent />
            </>
          }
        />
        {*/}
        <Route
          path='/report/experiment-report'
          element={
            <>
              <PageTitle breadcrumbs={reportBreadCrumbs}>
                {intl.formatMessage({id: 'SLIDEMENU.REPORT'})}
              </PageTitle>
              <ExperimentLog />
            </>
          }
        />
        <Route
          path='/report/content-report'
          element={
            <>
              <PageTitle breadcrumbs={reportBreadCrumbs}>
                {intl.formatMessage({id: 'SLIDEMENU.REPORT'})}
              </PageTitle>
              <ContentLog />
            </>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
